import dayjs from "dayjs";
import { formatDateString } from "./DateHelpers";
import { TextService } from "../Services/TextService";

// Date rules of the event form, shared by Skapa event and Ändra event: no times or deadline in the past,
// and the last day to sign up may not come after the event has started.

type EventTime = { start: Date | string, allDay?: boolean };

/** A full-day time is passed once its day is over, other times once they have started. */
export const isPassedTime = (start: Date | string, allDay: boolean, now: Date = new Date()) =>
    allDay ? dayjs(start).isBefore(dayjs(now), "day") : dayjs(start).isBefore(dayjs(now));

/** The start of the earliest time, or undefined when no time is chosen. */
export const getFirstStart = (times: EventTime[]) =>
    times.map(time => new Date(time.start)).sort((a, b) => a.getTime() - b.getTime())[0];

/**
 * The error to show for the deadline, or undefined when it is fine.
 * checkPassed is false on the edit page when the saved deadline was kept, so an event that has closed can be saved as it is.
 */
export const getDeadlineError = (deadline: string, times: EventTime[], checkPassed: boolean, now: Date = new Date()) => {
    if (!deadline || dayjs(deadline).year() <= 1970) {
        return undefined;
    }

    if (checkPassed && dayjs(deadline).isBefore(dayjs(now))) {
        return TextService.GetText("Create_Deadline_Passed");
    }

    const firstStart = getFirstStart(times);
    if (firstStart && dayjs(deadline).isAfter(dayjs(firstStart))) {
        return TextService.GetText("Create_Deadline_AfterFirstTime").replace("{0}", formatDateString(firstStart));
    }

    return undefined;
}
